export default {
  setHomeworks(state, data) {
    state.homeworks = data;
  },

  clearHomeworks(state) {
    state.homeworks = [];
  },
};
